import React from "react";

import { grey } from "@material-ui/core/colors";
import {
    Facebook as FacebookIcon,
    Instagram as InstagramIcon,
    MessageCircle as WhatsAppIcon
} from "lucide-react";

const ConnectionIcon = ({ connectionType }) => {

    const baseStyle = {
        color: "#25D366",
        width: 14,
        height: 14,
        display: "inline-block",
        verticalAlign: "middle"
    };

    return (
        <React.Fragment>
            {connectionType === 'whatsapp' && (
                <WhatsAppIcon style={baseStyle} />
            )}
            {connectionType === 'instagram' && (
                <InstagramIcon style={{ ...baseStyle, color: "#e1306c" }} />
            )}
            {connectionType === 'facebook' && (
                <FacebookIcon style={{ ...baseStyle, color: "#3b5998" }} />
            )}
        </React.Fragment>
    );
};

export default ConnectionIcon;
